import { render, staticRenderFns } from "./lightbulbIcon.vue?vue&type=template&id=3559cc60&"
import script from "./lightbulbIcon.vue?vue&type=script&lang=js&"
export * from "./lightbulbIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports